import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Sort = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.576 4.434a.8.8 0 0 0-1.132 0l-4.31 4.31a.8.8 0 1 0 1.132 1.132L12.01 6.13l3.844 3.845a.8.8 0 0 0 1.132-1.132l-4.41-4.41Zm-4.31 9.59a.8.8 0 0 0-1.132 1.132l4.41 4.41a.8.8 0 0 0 1.132 0l4.31-4.31a.8.8 0 0 0-1.132-1.132L12.11 17.87l-3.844-3.845Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Sort
